import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a30592"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentControlButton = _resolveComponent("ContentControlButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContentControlButton, {
      title: "Conteúdo anterior",
      type: "previous",
      disabled: !_ctx.hasPrevious,
      onClick: _ctx.onClickPrevious
    }, null, 8, ["disabled", "onClick"]),
    _withDirectives(_createVNode(_component_ContentControlButton, {
      disabled: _ctx.isNextLocked,
      title: "Próximo conteúdo",
      type: "next",
      onClick: _ctx.onClickNext
    }, null, 8, ["disabled", "onClick"]), [
      [_vShow, _ctx.hasNext || _ctx.isNextLocked]
    ]),
    _withDirectives(_createVNode(_component_ContentControlButton, {
      type: "finish",
      title: "Finalizar curso",
      onClick: _ctx.onClickFinish
    }, null, 8, ["onClick"]), [
      [_vShow, !_ctx.hasNext && !_ctx.isNextLocked]
    ])
  ]))
}